import { Box, Paper, Typography } from '@mui/material'
import { CurrencyCodeEnum } from '@/enums'
import { PersonalizationEngineChartType } from '@/state/personalization-engine/models'

import { getFormatNumber } from '@/utils'

export interface TooltipProps {
  data: PersonalizationEngineChartType
}

export const PEGraphicTooltip = ({ data }: TooltipProps) => {
  return (
    <Box p={2} component={Paper} textAlign="center">
      <Typography variant="caption" className="capitalize">
        {data.name}
      </Typography>
      <Typography fontWeight={700}>
        {Number(data.percentage).toFixed(2)}%
      </Typography>
      <Typography variant="caption">
        {getFormatNumber(
          Number(data.turnover.toFixed(2)),
          CurrencyCodeEnum.USD,
        )}
      </Typography>
    </Box>
  )
}
